import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Header_Layout from "./Components/Component/Header_Layout.jsx";
import Chatbot from "./Components/Component/Chatbot.jsx";

import Home from "./Page/Home.jsx";
import About from "./Page/About.jsx";
import Solution from "./Page/Our_Solution.jsx";
import Contact from "./Page/Contact.jsx";
import Gallery from "./Page/Blog.jsx";
import Gallerydetails from "./Page/Blog_Details.jsx";
import Gallery_1 from "./Page/Gallery_1.jsx";
import Gallery_2 from "./Page/Gallery_2.jsx";
import Gallery_3 from "./Page/Gallery_3.jsx";
import Gallery_4 from "./Page/Gallery_4.jsx";
import Gallery_5 from "./Page/Gallery_5.jsx";

const router = createBrowserRouter([
  {
    element: <Header_Layout />,
    children: [
      { path: "/", element: <Home />, handle: { heroHeader: true } },

      // Pages with inside-hero header
      { path: "/about", element: <About />, handle: { heroHeader: true } },
      { path: "/solution", element: <Solution />, handle: { heroHeader: true } },
      { path: "/gallery-details", element: <Gallerydetails />, handle: { heroHeader: true } },
   
      

      // Normal header pages
      { path: "/contact", element: <Contact />, handle: { heroHeader: true }  },
      { path: "/gallery", element: <Gallery />, handle: { heroHeader: true }  },
      

       { path: "/Gallery_1", element: <Gallery_1 />, handle: { heroHeader: true }  },
      { path: "/Gallery_2", element: <Gallery_2 />, handle: { heroHeader: true }  },
       { path: "/Gallery_3", element: <Gallery_3 />, handle: { heroHeader: true }  },
      { path: "/Gallery_4", element: <Gallery_4 />, handle: { heroHeader: true }  },
       { path: "/Gallery_5", element: <Gallery_5 />, handle: { heroHeader: true }  },
    ],
  },
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Chatbot />
    </>
  );
}

export default App;
